import api from '../../../core/api/client';

export const userService = {
  async getActiveUsers() {
    try {
      const response = await api.get('/users');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async getAllUsers() {
    try {
      const response = await api.get('/users/all');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async getUserById(userId) {
    try {
      const response = await api.get(`/users/${userId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async updateMyProfile(updates) {
    try {
      const response = await api.patch('/users/me', updates);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async updateUser(userId, updates) {
    try {
      const response = await api.patch(`/users/${userId}`, updates);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async updateUserStatus(userId, status) {
    try {
      const response = await api.patch(`/users/${userId}/status`, { status });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async updateUserRole(userId, role) {
    try {
      const response = await api.patch(`/users/${userId}/role`, { role });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async deleteUser(userId) {
    try {
      const response = await api.delete(`/users/${userId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};
